import { withStyles } from '@material-ui/core'

import { styles } from './styles'
import { DisconnectPageModal as View } from './DisconnectPageModal'

export const DisconnectPageModal = withStyles(styles)(View)
